import { f as r } from "./function-bind-context.js";
import { f as e } from "./function-uncurry-this.js";
import { i as t } from "./indexed-object.js";
import { t as a } from "./to-object.js";
import { l as i } from "./length-of-array-like.js";
import { a as s } from "./array-species-create.js";
var o = e([].push),
  n = function n(e) {
    var n = 1 == e,
      f = 2 == e,
      c = 3 == e,
      m = 4 == e,
      u = 6 == e,
      p = 7 == e,
      j = 5 == e || u;
    return function (d, l, h, v) {
      for (var y, x, b = a(d), w = t(b), I = r(l, h), g = i(w), k = 0, E = v || s, R = n ? E(d, g) : f || p ? E(d, 0) : void 0; g > k; k++) if ((j || k in w) && (x = I(y = w[k], k, b), e)) {
        if (n) R[k] = x;else if (x) switch (e) {
          case 3:
            return !0;
          case 5:
            return y;
          case 6:
            return k;
          case 2:
            o(R, y);
        } else switch (e) {
          case 4:
            return !1;
          case 7:
            o(R, y);
        }
      }
      return u ? -1 : c || m ? m : R;
    };
  },
  f = {
    forEach: n(0),
    map: n(1),
    filter: n(2),
    some: n(3),
    every: n(4),
    find: n(5),
    findIndex: n(6),
    filterReject: n(7)
  };
export { f as a };